// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3008) return "static/chunks/3008-7c2dc878abc3b9c2.js";
	if (chunkId === 1029) return "static/chunks/1029-aa0eba64c9467896.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1552 ? "c24d9160" : chunkId) + "." + {"562":"485c0f7d64c38a43","1552":"1d889b958e88d74d","2543":"ff3cbeb90edf8447","3796":"6c251d3157eaf995","4924":"accac27437ecfee6","4959":"0a1b5a12a5b68a08","5867":"1e75b10d0373bde1","5987":"b46a0e780de9d2e8","7732":"ab406326b92bc9ff","7926":"363ac677be547983"}[chunkId] + ".js";
};